<ion-app *ngIf="operatorTabOptions">
  <div class="app-background" [ngClass]="{
      'app-background__image': themeService.hasBackgroundImg(),
    }" [style.backgroundImage]="backgroundImage">
    <div class="app-container">
      <div class="app-content">

        <app-header (closeClicked)="onHeaderCloseClicked()"
          (themeClicked)="onHeaderThemeClicked()" (tabSelected)="onHeaderTabSelected($event)"></app-header>

        <ion-content>
          <ion-router-outlet id="main-content" [animated]="false" [swipeGesture]="false"></ion-router-outlet>

          <ion-modal #modal [initialBreakpoint]="isMobile() ? 1 : undefined"
            [breakpoints]="isMobile() ? [0, 1] : undefined" handle="false" [backdropDismiss]="false"
            [canDismiss]="canDismiss" [ngClass]="{
              'desktop-rounded-modal': !isMobile(),
              'mobile-rounded-modal': isMobile()
            }">
            <ng-template>
              <div class="drawer">
                <app-nav-button icon="xmark-circle" (clickEvent)="onThemeCloseClick()"
                  [size]="themeService.drawerConfig().closeButtonSize"
                  [ngClass]="themeService.drawerConfig().closeButtonPosition"></app-nav-button>

                <div class="typography-text-large-bold-primary drawer__game-name">
                  Choose a theme
                </div>

                <app-button label="Crypto" variant="secondary" stretch="fill"
                  (clickEvent)="themeService.switch(Theme.Crypto)" class="drawer__button drawer-margin" />

                <app-button label="Glow" variant="secondary" stretch="fill" (clickEvent)="themeService.switch(Theme.Glow)"
                  class="drawer__button" />

              </div>
            </ng-template>
          </ion-modal>
        </ion-content>
      </div>
    </div>
  </div>
</ion-app>